<template>
  <div class="text-body1 text-center">
    <q-icon name="fa fa-envelope" size="1rem"/>
    <div class="text-h6 q-mb-sm">
      Message Us
    </div>
    <p>
      <a href="mailto:support@privatefootprint.com">support@privatefootprint.com</a>
    </p>
    <q-separator class="q-my-lg" />
    <q-icon name="fa fa-phone" />
    <div class="text-h6 q-mb-sm">
      Call Us
    </div>
    <p>
      Monday to Friday<br>9am to 9pm EST
    </p>
    <p class="text-bold">
      866-906-6161 ext 2
    </p>
    <div class="text-bold text-uppercase">Or</div>
    <div class="q-mt-md">
      <a href="https://outlook.office.com/book/SupportCall@privatefootprint.com/" target="_blank">
        <q-btn label="Book a Support Call" color="black" unelevated no-caps rounded />
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({});
</script>
